import React, { FC } from 'react'
import Link from 'next/link'

import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Picture } from '@ucheba/ui/components/Picture'
import { IImage } from '@ucheba/store/institutions/item/types'

interface ILogoImage {
  isLink?: boolean
}

const LogoImage = styled(Picture)<ILogoImage>`
  height: 22px;
  display: inline;
  vertical-align: middle;
  margin-right: ${sv.spacing.xxsmall};

  cursor: ${({ isLink }) => isLink && 'pointer'};
`

interface ILogoProps {
  url: string | null
  logo: IImage
}

const Logo: FC<ILogoProps> = ({ url, logo }) => {
  if (url)
    return (
      <Link href={url} target='_blank'>
        <LogoImage
          isLink
          alt='логотип организации'
          fallbackUrl={logo?.fallbackUrl}
          webpUrl={logo?.webp}
        />
      </Link>
    )

  return (
    <LogoImage
      alt='логотип организации'
      fallbackUrl={logo?.fallbackUrl}
      webpUrl={logo?.webp}
    />
  )
}

export default Logo
